export async function initScriptTag({ env = 'production', brand = 'royal' }) {
  function isScriptAlreadyIncluded(src){
    var scripts = document.getElementsByTagName("script");
    for(var i = 0; i < scripts.length; i++) 
       if(scripts[i].getAttribute('src') == src) return true;
    return false;
  }
  const brandUrls = {
    'royal': {
      'test': `https://www.test1.royalcaribbean.com/unified-payment/dev/bundle.js`,
      'stage': `https://www.new.royalcaribbean.com/unified-payment/dev/bundle.js`,
      'production': `https://www.royalcaribbean.com/unified-payment/2.0.4/bundle.js`,
    },
    'celebrity': {
      'test': `https://www.test1.celebritycruises.com/unified-payment/dev/bundle.js`,
      'stage': `https://www.new.celebritycruises.com/unified-payment/dev/bundle.js`,
      'production': `https://www.celebritycruises.com/unified-payment/2.0.4/bundle.js`,
    }
  }
  const validEnvUrl = brandUrls[brand][env] || brandUrls['royal']['production']

  if (isScriptAlreadyIncluded(validEnvUrl)) {
    return true;
  }

  return new Promise((resolve, reject) => {
    let pScript = document.createElement("script");
    pScript.type = "text/javascript";
    pScript.charset = "utf-8";
    document.getElementsByTagName("head")[0].appendChild(pScript).src = validEnvUrl;
    pScript.onload = function() {
      resolve(true);
    };
    pScript.onerror = function() {
      reject(false);
    };
  })
}
